import script from "./AwaitBankAccountPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AwaitBankAccountPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AwaitBankAccountPanel.vue?vue&type=style&index=0&id=5b4efa5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4efa5b"]])

export default __exports__